module.exports = __webpack_public_path__ + "img/Asparagus.b06df5c3.svg";